<h1 mat-dialog-title class="no-margin">{{title.toUpperCase()}}
  <mat-icon class="close-icon" (click)="onNoClick()">close</mat-icon>
</h1>

<div class="dialog-body-overflow">
  <div class="content-box">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8"
           *ngIf="title == 'COMPETENZE ASSOCIATE' && filteredLista && filteredLista.length > 0">

      <ng-container matColumnDef="tipologia">
        <th mat-header-cell *matHeaderCellDef>Tipologia</th>
        <td mat-cell *matCellDef="let element"> {{element.descrizione}} </td>
      </ng-container>

      <ng-container matColumnDef="competenza">
        <th mat-header-cell *matHeaderCellDef>Competenza</th>
        <td mat-cell *matCellDef="let element"> {{element.tipologia.id}} - {{element.tipologia.descrizione}}
        </td>
      </ng-container>

      <ng-container matColumnDef="stato">
        <th mat-header-cell *matHeaderCellDef>Stato proposta</th>
        <td mat-cell *matCellDef="let element"> {{element.stato.descrizione}} </td>
      </ng-container>

      <ng-container matColumnDef="azioni">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>


    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8"
           *ngIf="title == 'PROFILI PROFESSIONALI ASSOCIATI' && filteredLista && filteredLista.length > 0">

      <ng-container matColumnDef="tipologia">
        <th mat-header-cell *matHeaderCellDef>Profilo</th>
        <td mat-cell *matCellDef="let element"> {{element.nomeProfilo}} </td>
      </ng-container>

      <ng-container matColumnDef="competenza">
        <th mat-header-cell *matHeaderCellDef>Area</th>
        <td mat-cell *matCellDef="let element"> {{element.descrizioneArea.id}} -
          {{element.descrizioneArea.descrizione}}</td>
      </ng-container>

      <ng-container matColumnDef="stato">
        <th mat-header-cell *matHeaderCellDef>Stato proposta</th>
        <td mat-cell *matCellDef="let element"> {{element.statoProposta.descrizione}} </td>
      </ng-container>

      <ng-container matColumnDef="azioni">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <mat-icon matTooltip="Dettaglio" class="green" (click)="dettaglioAssociazione(element)">
            search</mat-icon>
          <mat-icon matTooltip="Aggiungi codice profilo"
                    *ngIf="!element.codiceProfilo || element.codiceProfilo == null" class="green"
                    (click)="addCode(element)"> transit_enterexit</mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>



</div>
<div mat-dialog-actions class="actions">
  <button mat-fab extended class="searchbox-buttons ripristina-button" (click)="onNoClick()">
    <mat-icon>close</mat-icon>Chiudi
  </button>
</div>
